import { RssBoxIcon } from './RssBoxIcon';

/**
 * author: Gabriel
 * id 649343BD-3C91-43EA-9000-AE10520CAA2D
 * name rss-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/rss-box.svg
 * tags
 */
export const RssFeedBoxIcon = RssBoxIcon;
export default RssFeedBoxIcon